import React, { FunctionComponent, useEffect, useMemo } from 'react';
import Card from '@material-ui/core/Card';
import { IDealerData } from '../PostcodeCheckContainer';
import dealerSelectStyles from './dealerSelectStyles';
import { injectIntl } from 'react-intl';
import ButtonWithArrow from '../../presentation/Button/ButtonWithArrow';
import { Typography } from '@material-ui/core';
import useSearchDealer from '../../../react/useSearchDealer';
import Translation from '../../translation/Translation';

interface IDealerSelect extends IDealerData {
  intl: any;
  selectDealer: (data: any[]) => void;
  setIsLoadingResults: (isLoading: boolean) => void;
  onDealerSearchError: (hasError: boolean) => void;
}

const DealerSelect: FunctionComponent<IDealerSelect> = props => {
  const { dealerInformation, selectDealer, setIsLoadingResults, onDealerSearchError } = props;
  const styles = dealerSelectStyles();

  const { response, isLoading, error } = useSearchDealer(!!dealerInformation.dealership, dealerInformation.dealership, [
    dealerInformation,
  ]);

  const canShowDealerSelect = useMemo(() => {
    setIsLoadingResults(isLoading);

    return response && response[0];
  }, [response, isLoading]);

  useEffect(() => {
    const hasError: boolean = Boolean(error) || (response && !Boolean(Object.keys(response).length));

    if (hasError) {
      onDealerSearchError(hasError);
    }
  }, [error, response]);

  if (!canShowDealerSelect) {
    return null;
  }

  return (
    <Card className={styles.inputContainer}>
      <Typography variant="subtitle1" component="p" data-test="postcodeForm:dealerResult:name">
        {dealerInformation.dealership}
      </Typography>
      <Typography variant="subtitle1" component="p" data-test="postcodeForm:dealerResult:address">
        {response[0]?.streetName}
      </Typography>
      <div className={styles.buttonLabel} onClick={() => selectDealer(response)}>
        <ButtonWithArrow
          className={styles.actionButton}
          color={'primary'}
          iconSize={28}
          arrowSize={12}
          data-test={'button:selectDealer'}
        >
          <Translation id="spc.dealer.form.select" />
        </ButtonWithArrow>
      </div>
    </Card>
  );
};

export default injectIntl(DealerSelect);
